import React, {Component} from 'react'
import PropsTypes from 'prop-types'
import {ModalBody, ModalHeader} from "reactstrap"
import {_updateAccountData} from "../../../../services/apis/AccountServices"

class UpdateAccountDataForm extends Component {
    state = {
        modalData: this.props.modalData,
        isUpdating: false,
    }


    _handleChangeTextForm = field => e => {
        const {value} = e.target
        this.setState(({modalData}) => ({
            modalData: {
                ...modalData,
                [field]: value
            }
        }))
    }

    _handleSubmit = (e) => {
        e.preventDefault()

        const {modalData} = this.state
        this.setState({
            isUpdating: true
        })

        _updateAccountData(modalData._id, modalData)
            .then(result => {
                if (result.success) {
                    this.props.onCloseModal()
                    this.props.onUpdateListAccounts(modalData)
                }
            })
            .catch(err => {
                console.log(err)
            })

    }

    render() {
        const {email, password, recoverEmail, recoverPhone, note} = this.state.modalData
        const {isUpdating} = this.state

        return (
            <div>
                <ModalHeader toggle={this.toggle}>Edit </ModalHeader>
                <ModalBody>
                    <form onSubmit={this._handleSubmit}>
                        <div className="form-group">
                            <div className='row'>
                                <div className='col-3'><label>Email</label></div>
                                <div className='col-9'>
                                    <input className='form-control' value={email} placeholder='email'
                                           onChange={this._handleChangeTextForm('email')}/>
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <div className='row'>
                                <div className='col-3'><label>Password</label></div>
                                <div className='col-9'>
                                    <input className='form-control' value={password} placeholder='password'
                                           onChange={this._handleChangeTextForm('password')}/>
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <div className='row'>
                                <div className='col-3'><label>Phone</label></div>
                                <div className='col-9'>
                                    <input className='form-control' value={recoverPhone}
                                           placeholder='phone'
                                           onChange={this._handleChangeTextForm('recoverPhone')}/>
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <div className='row'>
                                <div className='col-3'><label>Recover Email</label></div>
                                <div className='col-9'>
                                    <input className='form-control' value={recoverEmail} placeholder='recover email'
                                           onChange={this._handleChangeTextForm('recoverEmail')}/>
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <div className='row'>
                                <div className='col-3'><label>Note</label></div>
                                <div className='col-9'>
                                    <input className='form-control' value={note} placeholder='Note'
                                           onChange={this._handleChangeTextForm('note')}
                                    />
                                </div>
                            </div>

                        </div>

                        <div className="form-group">
                            <button className="btn btn-success" type='submit' disabled={isUpdating}>Update</button>
                        </div>
                    </form>
                </ModalBody>
            </div>
        )
    }
}

UpdateAccountDataForm.propsTypes = {
    onCloseModal: PropsTypes.func.isRequired,
    onUpdateListAccounts: PropsTypes.func.isRequired,
    onToggleModal: PropsTypes.func.isRequired,
    modalData: PropsTypes.object.isRequired,
    onChangeModalData: PropsTypes.func.isRequired,
}

export default UpdateAccountDataForm


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/accounts/UpdateAccountDataForm.js